import React from 'react';
import { useLocation } from 'react-router-dom';

const HelpGuide: React.FC = () => {
    const location = useLocation();

    // Don't render on support page
    if (location.pathname === '/appraiser/support') {
      return null; 
    }

    return (
        <div className="flex items-center justify-center mt-6">
            <div className="text-center space-y-2 p-4">
                <h1 className="text-md font-semibold">Need help?</h1>
                <p className="text-sm">Our staff is ready to assist you M-F, 8-5pm CST.</p>
                <p className="text-sm">Email: <a href="mailto:sviorders@stewart.com" className="text-blue-600 hover:underline">sviorders@stewart.com</a></p>
                <p className="text-sm">Call: <a href="tel:8665620123" className="text-blue-600 hover:underline">866-562-0123</a></p>
                <p className="text-sm">For help with profile settings and configurations.</p>
                <p className="text-sm">Email: <a href="mailto:valuationvm@stewart.com" className="text-blue-600 hover:underline">valuationvm@stewart.com</a></p>
            </div>
        </div>
    );
};

export default HelpGuide;
